/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event-filter-wrapper{position:relative}.event-filter-wrapper [accordion]{margin-bottom:12px}.topbar-filter{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px}[mode=map] .filtering{margin:10px 0}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.filter/event.filter.component.scss.ngstyle.js.pre-build-optimizer.js